import { logEventString } from '@adv-frontend/yastore-modules/logger';
import { getThemeColor, getThemeMode, type ThemeMode } from '#shared/lib/theme';

export function logThemeModeShow() {
    const mode = getThemeMode();
    const color = getThemeColor();

    logEventString('Theme.ModeShow', mode, {
        mode,
        color,
    });
}

export function logThemeModeChange(mode: ThemeMode) {
    logEventString('Theme.ModeChange', mode, {
        mode,
        color: getThemeColor(),
    });
}

export function logThemeFeatureHintShow() {
    logEventString('Theme.FeatureHintShow', 'true');
}

export function logThemeFeatureHintConfirm() {
    logEventString('Theme.FeatureHintConfirm', 'true');
}
